import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from 'axios';
import { getCurrentUser } from "../slices/auth/login/thunk";
import { setAuthorization } from "../helpers/api_helper";
import { useComponentLoading } from "../contexts/GlobalLoadingContext";

const AuthProtected = (props : any) =>{
  const dispatch : any = useDispatch();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const { startLoading, stopLoading } = useComponentLoading('auth', 'Authentifizierung wird überprüft...', 100);

  // Check if this is a Frame.io page that should skip auth check
  const isFrameIOExplorer = location.pathname.includes('/frameio-assets');

  useEffect(() => {
    const checkAuth = async () => {
      // For Frame.io Explorer pages, allow access without standard auth
      if (isFrameIOExplorer) {
        setIsAuthenticated(true);
        setLoading(false);
        stopLoading();
        return;
      }

      startLoading();
      try {
        const authUser = localStorage.getItem("authUser") || sessionStorage.getItem("authUser");
        if (!authUser) {
          setIsAuthenticated(false);
          setLoading(false);
          stopLoading();
          return;
        }

        const { token } = JSON.parse(authUser);
        if (!token) {
          setIsAuthenticated(false);
          setLoading(false);
          stopLoading();
          return;
        }

        // Set authorization header
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setAuthorization(token); // Also update through the helper function

        // Verify token with backend
        await axios.get('/auth/me');

        // If we get here, the token is valid
        setIsAuthenticated(true);
        dispatch(getCurrentUser());

      } catch (error) {
        // Token is invalid, clear auth data from both storages
        localStorage.removeItem("authUser");
        sessionStorage.removeItem("authUser");
        delete axios.defaults.headers.common['Authorization'];
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
        stopLoading();
      }
    };

    checkAuth();
  }, [dispatch, startLoading, stopLoading, isFrameIOExplorer]);

  if (loading) {
    // Don't show own spinner, global loading context handles it
    return null;
  }

  if (!isAuthenticated && !isFrameIOExplorer) {
    // Pass the current location so we can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{props.children}</>;
};


export default AuthProtected;